export default "__VITE_ASSET__m5XrCcLS__"